<template>
  <div class="form-bottom-button"
      :class="{
        'form-bottom-label': labelSlot,
        'transparent': transparent
      }">
    <div class="form-bottom-button__inner">
      <div class="label">
        <slot name="label"/>
      </div>
      <mt-button
        :type="type"
        :size="size"
        :class="{ 'radius': facadeArr.indexOf('radius') >= 0 }"
        @click="submit"
      >{{ text || '保存' }}</mt-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'form-button-buttom',
  props: {
    text: {
      type: String,
      default: ''
    },
    // 按钮场景（颜色）
    type: {
      type: String,
      default: 'primary'
    },
    // 外观
    facade: {
      type: [String, Array],
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    transparent: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    labelSlot() {
      return this.$slots['label']
    },
    facadeArr() {
      const { facade } = this
      return facade instanceof Array ? facade : facade ? [facade] : []
    }
  },
  methods: {
    submit() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-bottom-button {
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  position: fixed;
  font-size: .32rem;
  // iphoneX only
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  .form-bottom-button__inner {
    display: flex;
    z-index: 1;
    padding: .18rem .48rem;
  }
  .mint-button {
    width: 100%;
    &.mint-button--small {
      height: 44px;
      line-height: 44px;
      font-size: .32rem;
    }
  }
  &.form-bottom-label {
    background-color: #fff;
    align-items: center;
    .label {
      flex: 1;
      display: flex;
      align-items: center;
      text-align: center;
    }
    .form-bottom-button__inner {
      .mint-button {
        width: max-content;
        height: .88rem;
        line-height: .88rem;
        border-radius: .12rem;
        padding: 0 .4rem;
        font-size: .32rem;
        &.radius {
          border-radius: 30px;
          margin-right: 26px;
        }
      }
    }
  }
  &.transparent {
    background-color: transparent;
    .form-bottom-button__inner {
      background-color: transparent;
    }
  }
}
</style>
